import React, { Fragment } from "react";
import { CommonModal } from "./commonModal";
import { InvoiceDownloadModal } from "./invoiceDownloadModal";

function ModalsPrivateLayoutComponent(){
    return <Fragment>
        <InvoiceDownloadModal />
        <CommonModal />
    </Fragment>
}

export const ModalsPrivateLayout = React.memo(ModalsPrivateLayoutComponent)